import {ActionEnum} from "../action.enum";
import {UserAreaDetailMenuEnum} from "../../enums/rights/UserAreaDetailMenuEnum";
import {UserAreaDTO} from "../../models/rights/user-area/UserAreaDTO";

export namespace UserAreaDetailActions {

  export class Fetch {
    static readonly type = ActionEnum.USER_AREA_DETAIL_FETCH;

    constructor(public readonly userAreaId: string) {}
  }

  export class ReFetch {
    static readonly type = ActionEnum.USER_AREA_DETAIL_RE_FETCH;

    constructor() {}
  }

  export class SetPage {
    static readonly type = ActionEnum.USER_AREA_DETAIL_SET_PAGE;

    constructor(public readonly page: UserAreaDetailMenuEnum) {}
  }

  export class UpdateBasisInfo {
    static readonly type = ActionEnum.USER_AREA_DETAIL_UPDATE_BASIS_INFO;

    constructor(public readonly userArea: UserAreaDTO) {}
  }

  export class UpdateActualization {
    static readonly type = ActionEnum.USER_AREA_DETAIL_UPDATE_ACTUALIZATION;

    constructor(public readonly userArea: UserAreaDTO) {}
  }

  export class Reset {
    static readonly type = ActionEnum.USER_AREA_DETAIL_RESET;

    constructor() {}
  }
}
